<mat-form-field appearance="outline" class="w-100 lazy-drop-down {{ class }}">
    <mat-label>{{ label }}</mat-label>
    <mat-select
        placeholder="{{ placeholder }}"
        class="form-control"
        [formControl]="control"
        msInfiniteScroll
        (infiniteScroll)="onScroll()"
        [complete]="offset >= totalCount"
        (selectionChange)="onSelectionChange($event)"
        [multiple]="multiple"
    >
       
        <mat-option>
            <ngx-mat-select-search
                [formControl]="searchControl"
                [clearSearchInput]="search_entiry.clear_search_input"
                placeholderLabel="Find name..."
                noEntriesFoundLabel="No matching name found"
            ></ngx-mat-select-search>
        </mat-option>
        <mat-checkbox *ngIf="showSelectAll" (change)="toggleSelectAll($event)">
            Select All
        </mat-checkbox>
        <mat-option
            (click)="onSelect(item.id)"
            *ngFor="let item of items"
            [value]="item.id"
        >
            {{ item.name }}
        </mat-option>
    </mat-select>

    <button
        *ngIf="control.value && showClear"
        mat-icon-button
        class="clear-icon"
        (click)="$event.stopPropagation(); clearSelection($event)"
    >
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
